import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="ytca-container flex min-h-[60vh] flex-col items-center justify-center py-24 text-center">
      <p className="font-display text-6xl font-semibold text-primary">404</p>
      <h1 className="mt-4 font-display text-3xl font-semibold">This page wandered off to make art.</h1>
      <p className="mt-3 max-w-md text-muted-foreground">The page you're looking for doesn't exist — but there's plenty else to explore.</p>
      <Button asChild className="mt-6 rounded-full" data-testid="notfound-home-button"><Link to="/">Back Home</Link></Button>
    </div>
  );
}
